import React from 'react';
import { CheckCircle2, Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhatYouGet() {
  const deliverables = [{
    title: 'The Sunday Reset Protocol',
    desc: 'A 20-page guide to regulating your nervous system in 22 minutes.'
  }, {
    title: 'The Sunday Brain-Drain (CNS Sweep)',
    desc: 'A template to close the "open tabs" in your mind.'
  }, {
    title: "The 'Minimalist Monday' Launch Map",
    desc: 'Pre-frontload your sensory decisions to eliminate morning fatigue.'
  }, {
    title: 'The No-Guilt Boundary Shield',
    desc: 'Copy-paste scripts to say "No" to energy vampires without the heart-racing guilt.'
  }, {
    title: 'The 10-Minute Sleep Environment Audit',
    desc: 'A checklist to turn your bedroom back into a sanctuary.'
  }];
  return <section className="bg-white py-20 md:py-28 px-6" data-id="element-173">
      <div className="max-w-4xl mx-auto" data-id="element-174">
        <FadeIn data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-serif text-forest mb-16 text-center" data-id="element-176">
            Inside The Rescue Kit
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-177">
            {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-178">
                <div className="bg-cream/50 p-8 rounded-2xl h-full border border-sage/20 hover:border-sage/50 transition-colors" data-id="element-179">
                  <CheckCircle2 className="w-8 h-8 text-sage mb-4" data-id="element-180" />
                  <h3 className="text-xl font-serif text-forest mb-3" data-id="element-181">
                    {item.title}
                  </h3>
                  <p className="text-charcoal/80 font-light" data-id="element-182">{item.desc}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.5} data-id="element-183">
            <div className="bg-forest text-cream p-8 md:p-10 rounded-2xl relative overflow-hidden" data-id="element-184">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-185"></div>
              <div className="flex items-start gap-4 relative z-10" data-id="element-186">
                <Star className="w-8 h-8 text-gold flex-shrink-0 mt-1" fill="currentColor" data-id="element-187" />
                <div data-id="element-188">
                  <span className="text-gold text-sm font-bold tracking-wider uppercase mb-2 block" data-id="element-189">
                    Bonus Included
                  </span>
                  <h3 className="text-2xl font-serif text-white mb-2" data-id="element-190">
                    Monday Morning 'First Hour' Checklist
                  </h3>
                  <p className="text-cream/80 font-light" data-id="element-191">
                    A step-by-step guide to starting your week on "Easy Mode."
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>
        </FadeIn>
      </div>
    </section>;
}